import Aims from '../../downloads/img/pages/aims.webp';
import Constitution from '../../downloads/img/pages/constitution.webp';
import Stamp from '../../downloads/img/pages/stamp.webp';

const pagesObj = [
    {
        id: 17,
        name: 'aims.webp',
        link: Aims
    },
    {
        id: 18,
        name: 'constitution.webp',
        link: Constitution
    },
    {
        id: 19,
        name: 'stamp.webp',
        link: Stamp
    },
]

export {Aims, Constitution, Stamp, pagesObj};